<template>
    <div :id="id">
        <form-label v-if="label" :text="fieldLabel" :hint="fieldHint" :for="id"></form-label>
        <div class="uk-form-controls">
            <div class="uk-grid-small uk-child-width-auto uk-grid">
                <label v-for="[itemValue, itemLabel] in castValues.entries()">
                    <input class="uk-radio" :class="{'uk-form-danger': isDanger, 'uk-form-success': isSuccess}" type="radio" :name="name" :value="itemValue" :disabled="!enabled" v-model="fieldValue" @change="triggerChangeAndValidate()" @blur="doValidate">
                    {{ itemLabel }}
                </label>
            </div>
        </div>
        <form-error v-for="(error, index) in errors" :key="index" :error="error"></form-error>
    </div>

</template>

<script>
  import FormField from "rubinred/forms/js/mixins/FormField";

  export default {
    mixins: [FormField],
    props: {
      values: {
        type: [Object, Map],
        required: true,
      },
    },
    computed: {
      castValues() {
        if(! (this.values instanceof Map)) {
          let values = new Map();
          for (var key in this.values) {
            // skip loop if the property is from prototype
            if (!this.values.hasOwnProperty(key)) continue;

            var value = this.values[key];
            values.set(key, value);
          }
          return values;
        }

        return this.values;
      }
    }
  }
</script>



// WEBPACK FOOTER //
// public/themes/frontend/uikit3/extensions/rubinred/forms/assets/js/components/FormRadios.vue